import * as angular from "angular";
import {BringozApi} from "../../persistence-layer/models/bringoz-api.model";

angular
  .module('bringoz.admin.configuration-profiles')
  .service('ConfigurationProfilesAPI', ConfigurationProfilesAPI);

function ConfigurationProfilesAPI(): BringozApi {
  return {
    base: `/configuration-profile`,
    infiniteScroll: {
      address: `/configuration-profile`,
      cmd: 'GET'
    },
    actions: {
      getDefaultProfile: {
        address: '',
        cmd: 'GET',
        updateable: true
      },
      createOne: {
        address: '',
        cmd: 'PUT',
        updateable: true
      },
      getOne: {
        address: '{id}',
        cmd: 'GET',
        updateable: true
      },
      updateOne: {
        address: '{id}',
        cmd: 'POST',
        updateable: true
      },
      assignAccounts: {
        address: '{profileId}/assign',
        cmd: 'POST',
        updateable: true
      },
      deleteOne: {
        address: '{id}',
        cmd: 'DELETE',
        updateable: true
      }
    }
  }
}
